export enum SupportTicketStateEnum {
    CREATED = 'cre',
    ON_REVISION = 'rev',
    REJECTED = 'rej',
    RESOLVED = 'res',
    DISCUSSION = 'dis',
    BANNED = 'ban',
}
